import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { getAppointedPersonsLV } from '../../../services/plantSafetyWorkPermitService';
import { notifyAOCSign } from '../../../services/lvWorkPermitFlowService';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  permitId: number;
  onSuccess?: () => void;
}

const AOCSignModal: React.FC<Props> = ({ isOpen, onClose, permitId, onSuccess }) => {
  const [appointedPersons, setAppointedPersons] = useState<any[]>([]);
  const [selectedPerson, setSelectedPerson] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      loadAppointedPersons();
    }
  }, [isOpen]);

  const loadAppointedPersons = async () => {
    try {
      const response = await getAppointedPersonsLV();
      setAppointedPersons(response?.data || response || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    if (!selectedPerson) {
      alert('Please select an appointed person');
      return;
    }

    try {
      setLoading(true);

      await notifyAOCSign(permitId, {
        user_ids: [Number(selectedPerson)],
      });

      onSuccess?.();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">Notify to Sign</h2>

          <button onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Appointed Person</label>

          <select value={selectedPerson} onChange={(e) => setSelectedPerson(e.target.value)} className="w-full border rounded-lg px-3 py-2">
            <option value="">Select Appointed Person</option>

            {appointedPersons.map((person) => (
              <option key={person.id} value={person.id}>
                {person.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 border rounded-lg">
            Cancel
          </button>

          <button onClick={handleSubmit} disabled={loading} className="px-4 py-2 bg-blue-600 text-white rounded-lg">
            {loading ? 'Submitting...' : 'Done'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AOCSignModal;
